import React, { Component } from "react";
 
import axios from "../../../axios-order";
import SimpleReactValidator from 'simple-react-validator';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";


class Immigartion extends Component {
  constructor(props){
    super(props)          
    this.validator = new SimpleReactValidator();
  }
  state = {
    immigration: {
      name: '',
      email:'',
      country:'',
      contact_no:'',
      description:''
    },
    countries: [],
  };
  componentDidMount() {
    axios
      .get("https://restcountries.eu/rest/v2/all")
      .then((res) => {
        this.setState({
          countries: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handleUserInput = (e) => {
    const value = e.target.value;
    this.setState({
      ...this.state,
      immigration: {
        ...this.state.immigration,
        [e.target.name]: value,
      },
    });
  };
  submitForm=(e)=>{
    e.preventDefault();
    if (this.validator.allValid()) {
      console.log(this.state.immigration)
      this.props.onSetLoader(); 
      axios.post('immigration', this.state.immigration)
      .then( response => { 
              console.log(response)
              this.props.onSetLoader();
              this.props.history.replace("/");
      })
      .catch( error => {            
          console.log(error)
          this.props.onSetLoader(); 
      });
    
      return true      
    } else {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
    
  }
  render() {
    return (
      <div>
        <div className="banner-image country">
          <div className="mx-width">
            <div className="banner-text">
              <h1 className="bg-text1 mb-1">
                <span className="text-color2">Immigration</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="my-3">
          <h2 className="text-color1 text-center heading2 mb-0">
            Fill the Form
          </h2>
        </div>
        <div className="form-section">
          <div className="ms-width">
            <form action="" method="post">
              <div className="form-container mb-4">
                <h4 className="heading4 text-color2 mb-3 pl-3">Immigration</h4>
                <div className="form-wrap mc-border">
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="name" className="form-label1">
                          Name
                        </label>
                        <input
                          id="name"
                          className="form-control form-input1"
                          name="name"
                          placeholder="Name"
                          value={this.state.immigration.name}
                          onChange={this.handleUserInput}
                        />
                         {this.validator.message('Name', this.state.immigration.name, 'required|alpha_space', { className: 'text-danger' })}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label1">
                          Email
                        </label>
                        <input
                          id="email"
                          className="form-control form-input1"
                          type="text"
                          name="email"
                          placeholder="Email"
                          value={this.state.immigration.email}
                          onChange={this.handleUserInput}
                        />
                        {this.validator.message('Name', this.state.immigration.email, 'required|email', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="contact_no" className="form-label1">
                          Contact
                        </label>
                        <input
                          id="contact_no"
                          name="contact_no"
                          className="form-control form-input1"
                          type="text"
                          placeholder="Contact"
                          value={this.state.immigration.contact_no}
                          onChange={this.handleUserInput}
                        />
                        {this.validator.message('Contact', this.state.immigration.contact_no, 'required|phone', { className: 'text-danger' })}

                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="country" className="form-label1">
                          Country
                        </label>
                        <select
                          className="form-control form-input1"
                          name="country"
                          value={this.state.immigration.country}
                          onChange={this.handleUserInput}
                        >
                          {this.state.countries.map((countary) => {
                            return (
                              <option
                                key={countary.name}
                                value={countary.name}
                              >
                                {countary.name}
                              </option>
                            );
                          })}
                        </select>
                        {this.validator.message('Country', this.state.immigration.country, 'required', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="description" className="form-label1">
                          Leave a Short Messaege
                        </label>
                        <textarea
                          name="description"
                          id="description"
                          rows="4"
                          className="form-control form-input1"
                          value={this.state.immigration.description}
                          onChange={this.handleUserInput}
                        >
                          asdsa
                        </textarea>
                        {this.validator.message('description', this.state.immigration.description, 'required|alpha_num_dash_space', { className: 'text-danger' })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group text-right mt-4">
                  <button type="submit" className="btn btn-apply" onClick={this.submitForm}>
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {   
  return {
      onSetLoader: () => dispatch({type: 'SET_LOADER'}) 
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Immigartion));
